import LogoIcon from '../static/img/logo.svg';

import React from 'react';

export const PageLoader = () => {
    return (
        <div className='w-full flex items-center justify-center pt-72'>
            <img alt="Loading" src={LogoIcon} height={100}/>
            <div>Software for music schools</div>
        </div>
    )
}
